import { createLogic } from 'redux-logic'
import {
  SET_PENDANT_OPTIONS,
  SET_CANCEL_TWR_OPTIONS,
} from '../constants/programOptions'
import { PROGRAM_OPTIONS_TIMEOUT } from '../constants/timeouts'

const submitDetectorLogic = createLogic({
  type: SET_PENDANT_OPTIONS,
  cancelType: SET_CANCEL_TWR_OPTIONS,
  warnTimeout: PROGRAM_OPTIONS_TIMEOUT,

  transform({ getState, action }, next) {
    const { form: { MezzoMonitoringFormPendant: { values: { pendant, TXID } } } } = getState()
    const optionValue = `${TXID}0510${pendant}`
    const programOptions = [{ number: 0, value: optionValue }]

    next({
      ...action,
      programOptions,
    })
  },

  process({ action }, dispatch, done) {
    global.programOptionsChannel.perform('update_program_options', { programOptions: action.programOptions })
    done()
  },
})

export default submitDetectorLogic
